// extracted by mini-css-extract-plugin
export default {"activityContainer":"sJMb28PeWaAccWF8if_o"};